import httpClient from '@/http-client'

export const getProfile = (Options = {}) => {
  return httpClient
    .get('/api/home/staff-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/home/staff-change-photos', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changePassword = data => {
  return httpClient
    .post('/api/home/staff-change-passwords', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/staff-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTotalMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/staff-get-total-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTotalMyApproval = (Options = {}) => {
  return httpClient
    .get('/api/home/staff-get-total-my-approvals', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMyApproval = (Options = {}) => {
  return httpClient
    .get('/api/home/staff-my-approvals', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApproveTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/staff/approve-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getClassByTeacher = (Option = {}) => {
  return httpClient
    .get('/api/home/staff/get-classes-by-teachers', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubjectByTeacher = (Option = {}) => {
  return httpClient
    .get('/api/home/staff/get-subjects-by-teachers', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPaymentHistory = (Option = {}) => {
  return httpClient
    .get('/api/home/staff/get-payment-histories', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationHistory = (Option = {}) => {
  return httpClient
    .get('/api/home/staff/get-notification-histories', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/staff/notification-types', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changeStatus = (Option = {}) => {
  return httpClient
    .post('/api/home/staff/approvals', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const findProfile = (Options = {}) => {
  return httpClient
    .get('/api/home/staff/profile-approvals', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getProfile,
  uploadPhoto,
  changePassword,
  getMyRequest,
  getTotalMyRequest,
  getTotalMyApproval,
  getMyApproval,
  getApproveTypes,
  getClassByTeacher,
  getSubjectByTeacher,
  getPaymentHistory,
  getNotificationHistory,
  getNotificationTypes,
  changeStatus,
  findProfile
}
